import { useState } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { isAdmin } from "../util/SecurityUtils";
import { Icon } from "../components/common/Icon";
import LadderFilterButtons from "../components/common/LadderFilterButtons";
import LadderStandings from "../components/players/LadderStandings";

function Players() {
  const [ladderId, setLadderId] = useState(1);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="base-container">
      <div className="table-header header">
        <span className="table-title">{t("officialLadders")}</span>
        {isAdmin() ? (
          <Button
            variant="outline-light"
            size="sm"
            onClick={() => navigate(`/ladders/${ladderId}/settings`)}
            className="table-button table-button-icon"
            aria-label={t("ladderSettings")}
            title={t("ladderSettings")}
          >
            <Icon name="Gear" />
          </Button>
        ) : null}
      </div>
      <div className="players-filters">
        <LadderFilterButtons selectedLadderId={ladderId} onLadderChange={setLadderId} />
      </div>
      <div className="content">
        <LadderStandings ladderId={ladderId} />
      </div>
    </div>
  );
}

export default Players;
